import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './FaqAccordion.css';

// Accessible FAQ accordion (button + region, aria-expanded/aria-controls).
// `items` = [{ q, a }]. The JSON-LD FAQPage markup is built by the page, not here.
function FaqAccordion({ heading, items = [] }) {
  const [open, setOpen] = React.useState(-1);
  return (
    <div className={s.block}>
      {heading ? <h2 className={s.heading}>{heading}</h2> : null}
      <div className={s.list}>
        {items.map((it, i) => {
          const isOpen = open === i;
          const id = `faq-panel-${i}`;
          const btnId = `faq-btn-${i}`;
          return (
            <div className={s.item} key={it.q}>
              <h3 className={s.qHead}>
                <button
                  type="button"
                  id={btnId}
                  className={s.qBtn}
                  aria-expanded={isOpen}
                  aria-controls={id}
                  onClick={() => setOpen(isOpen ? -1 : i)}
                >
                  <span>{it.q}</span>
                  <svg viewBox="0 0 24 24" aria-hidden="true" className={`${s.chev} ${isOpen ? s.chevOpen : ''}`}>
                    <path d="m6 9 6 6 6-6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </button>
              </h3>
              <div
                id={id}
                role="region"
                aria-labelledby={btnId}
                className={`${s.panel} ${isOpen ? s.panelOpen : ''}`}
                hidden={!isOpen}
              >
                <p>{it.a}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default withStyles(s)(FaqAccordion);
